import { ActionTypeList } from '../../constants'

const initialState = {
    loading: false,
    isSuccess: false,
    successMessage: '',
    toShowMessage: false,
    error: "",
};

const userDeleteStatusPayload = (state = initialState, action) => {

    switch (action.type) {
        case ActionTypeList.USER_SETTING_DELETED:
            return {
                loading: false,
                isSuccess: true,
                successMessage: action.payload,
                toShowMessage: true,
                error: ""
            };
        case ActionTypeList.USER_SETTING_DELETE:
            return {
                loading: true,
                isSuccess: false,
                toShowMessage: true,
                error: action.payload
            };
        case ActionTypeList.USER_SETTING_DELETED_HIDE_MSG:
            return {
                loading: false,
                toShowMessage: false,
                isSuccess: false,
                error: "",
                successMessage: ``
            };
        default:
            return state;
    }
}

export default userDeleteStatusPayload;